import { withErrorBoundary, useErrorBoundary } from "react-use-error-boundary";
import { Button } from "@mui/material";
import { Auth } from "aws-amplify";
const ErrorBoundaryComponent = withErrorBoundary(({ children }: any) => {
  const [error, resetError] = useErrorBoundary();

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        <img
          src={require("./assets/404Image-transparent.png")}
          alt=""
          height={400}
          width={500}
        />
        <Button
          onClick={() => {
            Auth.signOut()
            localStorage.clear();
            window.location.href = "/";
          }}
          variant="contained"
        >
          Logout
        </Button>
      </div>
    );
  }

  return <div>{children}</div>;
});

export default ErrorBoundaryComponent;
